/**
 * Light or dark, for the apps that offer both.
 *
 * The choice is one attribute on <html>; every colour then resolves through the
 * roles in styles.css, so no component knows which theme is on. Both panels set
 * the stored choice before first paint from public/theme-init.js, which reads
 * the same storage key as this module.
 */
export type ThemePreference = 'light' | 'dark' | 'system';

export const THEME_STORAGE_KEY = 'theme';

export function getThemePreference(): ThemePreference {
    try {
        const stored = localStorage.getItem(THEME_STORAGE_KEY);
        if (stored === 'light' || stored === 'dark') return stored;
    } catch {
        // Private browsing can block storage; following the OS is a fine default.
    }
    return 'system';
}

export function setThemePreference(preference: ThemePreference): void {
    const root = document.documentElement;
    if (preference === 'system') root.removeAttribute('data-theme');
    else root.setAttribute('data-theme', preference);
    try {
        if (preference === 'system') localStorage.removeItem(THEME_STORAGE_KEY);
        else localStorage.setItem(THEME_STORAGE_KEY, preference);
    } catch {
        // The preference simply will not persist; this session still honours it.
    }
}
